/* eslint-disable no-param-reassign */
import { createSlice, SerializedError } from '@reduxjs/toolkit'
import { getPageConfig } from './asyncThunks'
import { Status } from '../types'

interface PageConfigSlice {
  status: Status
  config: any
  error: string | SerializedError | null | undefined
}

const initialState: Readonly<PageConfigSlice> = {
  status: 'idle',
  config: {},
  error: null
}

const pageConfigSlice = createSlice({
  name: 'pageConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPageConfig.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(getPageConfig.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.config = action.payload.pageConfig
      })
      .addCase(getPageConfig.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload as PageConfigSlice['error']
      })
  }
})

export default pageConfigSlice.reducer
